import { faBug } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function debugMode() {
    return (
        <div data-cy="historic-icon-debugMode">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.debugMode" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faBug} size="lg" style={{ color: 'orange' }} />
            </Whisper>
        </div>
    );
}
